/* @flow */

import {
    type MetodosPagamento,
} from './types';
import { type Pedido } from '../pedidos/types';
import {
    PAGAMENTO_CARTAO_CREDITO,
    PAGAMENTO_CARTAO_DEBITO,
    PAGAMENTO_DINHEIRO_SEM_TROCO,
    PAGAMENTO_DINHEIRO_COM_TROCO,
    PAGAMENTO_BOLETO,
    PAGAMENTO_JA_REALIZADO,
    PAGAMENTO_VALE_ALIMENTACAO,
    PAGAMENTO_SODEXO,
    PAGAMENTO_ALELO,
    PAGAMENTO_TICKET,
} from './constants';

const traduzirFormaPagamento = ({ troco, formaPagamento }: Pedido): ?MetodosPagamento => {
    if (!formaPagamento) {
        return null;
    }

    if (formaPagamento.tipo.id === 6) {
        return PAGAMENTO_JA_REALIZADO;
    }

    if (formaPagamento.tipo.id === 3) {
        return PAGAMENTO_VALE_ALIMENTACAO;
    }

    if (formaPagamento.id === 11) {
        return troco ? PAGAMENTO_DINHEIRO_COM_TROCO : PAGAMENTO_DINHEIRO_SEM_TROCO;
    }

    if (formaPagamento.id === 31) {
        return PAGAMENTO_SODEXO;
    }

    if (formaPagamento.id === 15) {
        return PAGAMENTO_ALELO;
    }
    if (formaPagamento.id === 17) {
        return PAGAMENTO_TICKET;
    }

    if (formaPagamento.id === 37) {
        return PAGAMENTO_BOLETO;
    }

    if (formaPagamento.tipo.id === 1) {
        return PAGAMENTO_CARTAO_DEBITO;
    }

    if (formaPagamento.tipo.id === 2) {
        return PAGAMENTO_CARTAO_CREDITO;
    }

    return null;
};

export default traduzirFormaPagamento;
